export default __webpack_public_path__ + "static/media/LAS0130.34I-30456_-17558_0.16014d5f.jpg";